export default  {
  autoUpdate: true,
  alpha: {
    start: 1,
    end: 1
  },
  scale: {
    start: 0.35,
    end: 0.1,
    minimumScaleMultiplier: 1
  },
  color: {
    start: "#FFFFFF",
    end: "#B9B9B9"
  },
  speed: {
    start: 0,
    end: 0,
    minimumSpeedMultiplier: 1
  },
  acceleration: {
    x: 0,
    y: 0
  },
  maxSpeed: 0,
  startRotation: {
    min: 0,
    max: 0
  },
  noRotation: true,
  rotationSpeed: {
    min: 0,
    max: 0
  },
  lifetime: {
    min: 0.4,
    max: 0.4
  },  
  blendMode: "normal",
  frequency: 0.007,
  emitterLifetime: -1,
  maxParticles: 5000,
  pos: {
    x: 0,
    y: 0
  },
  addAtBack: false,
  spawnType: "point"
};


// WEBPACK FOOTER //
// ./src/components/ParticleSystem/emitters/trail.ts